<template>
  <div>
    <div class="item_box">
      <span>登陆密码</span>
      <span>已设置。密码至少6位字符，支持数字、字母和除空格外的特殊字符，且必须同时包含数字和大小写字母。</span>

      <span @click="editShow('1')">修改</span>
    </div>
    <div class="item_line"></div>
    <div class="item_box">
      <span>安全手机</span>
      <span>已绑定：{{
        userList.phonenumber
        ? userList.phonenumber.substring(0, 3) +
        "******" +
        userList.phonenumber.substring(9, 11)
        : ""
      }}</span>
      <span @click="editShow('3')">修改</span>
    </div>
    <div class="item_line"></div>
    <!-- <div class="item_box">
      <span>安全邮箱</span>
      <span
        v-if="!userList.email || userList.emailStatus == 0"
        style="color: #86909c"
        >您暂未设置邮箱，绑定邮箱可以用来找回密码、接收通知等。</span
      >
      <span v-else-if="userList.emailStatus === 1" style="color: #86909c"
        >邮箱待验证</span
      >
      <span v-else-if="userList.emailStatus === 3" style="color: red"
        >请重新绑定邮箱</span
      >
      <span v-else>{{ userList.email.replace(/(\d{7})@/, "*****") }}</span>
      <span @click="editShow('4')">{{
        !userList.email ? "绑定" : "修改"
      }}</span>
    </div> -->
    <div class="item_line"></div>
    <div class="item_box">
      <span>微信绑定</span>
      <span v-if="userList.openUserid != null && userList.openUserid != ''" style="color: #86909c">已绑定</span>
      <span v-else style="color: #86909c">您暂未绑定微信，绑定微信可以有效的保护账号的安全。</span>

      <span @click="editShow('6')">{{
        !userList.openUserid ? "绑定" : "解绑"
      }}</span>
    </div>

    <el-dialog :title="dialogTitle" v-model="eidtVisible" @closed="handleClose" align-center width="480px" :close-on-click-modal="false">
      <div v-if="editType == 1">
        <div style="font-size: 0.12rem; color: #86909c; margin-bottom: 0.2rem">
          为了保护账号安全，请先完成短信验证(+86-{{
            userList.phonenumber
            ? userList.phonenumber.substring(0, 3) +
            "******" +
            userList.phonenumber.substring(9, 11)
            : ""
          }})
        </div>
        <div class="yzmInt">
          <!-- <span style="color: #86909C;font-size: 0.14rem;">验证码</span> -->
          <el-input border="none" v-model="yzm_code" placeholder="验证码" style="flex-grow: 1" />
          <span style="
              color: #C01A26;
              cursor: pointer;
              font-size: 0.14rem;
              width: 1rem;
              margin-left: 0.1rem;
            " @click="
              fs_yzm(
                dialogTitle == '绑定邮箱'
                  ? '4'
                  : '' || dialogTitle == '密码修改'
                    ? '2'
                    : '' || dialogTitle == '修改手机'
                      ? '3'
                      : ''
              )
              ">{{ yzmTitle }}</span>
        </div>
        <div class="dataBtnSubmit" @click="
          qr_yzm(
            dialogTitle == '绑定邮箱'
              ? '4'
              : '' || dialogTitle == '密码修改'
                ? '2'
                : '' || dialogTitle == '修改手机'
                  ? '3'
                  : ''
          )
          ">
          下一步
        </div>
      </div>

      <div v-if="editType == 2">
        <div style="font-size: 0.12rem; color: #86909c; margin-bottom: 0.2rem"></div>
        <div class="yzmInt">
          <el-input border="none" v-model="newPassword" placeholder="新密码1" />
        </div>
        <div style="width:100%;height:10px">
            <!-- 展示长度条 -->
            <div class="bar" v-if="newPassword !== '' && newPassword !== undefined"
              :style="{ background: barColor, width: width + '%' }">
              <!-- 展示文字 -->
              <div class="strength" :style="{ color: barColor }" v-if="newPassword !== '' && newPassword !== undefined">
                {{ strength }}
              </div>
            </div>
          </div>
        <div class="dataBtnSubmit" @click="tg_xgmm()">确认</div>
      </div>

      <div v-if="editType == 3">
        <div style="font-size: 0.12rem; color: #86909c; margin-bottom: 0.2rem">
          验证成功，绑定新手机
        </div>
        <div class="yzmInt" style="margin-bottom: 0.2rem">
          <el-input border="none" v-model="newCell" placeholder="新手机号" />
        </div>
        <div class="yzmInt">
          <el-input border="none" v-model="yzm_code1" style="width: 80%" placeholder="验证码" />

          <span style="color: #C01A26; font-size: 0.14rem; flex: none;cursor: pointer;"
            @click="fs_yzm(dialogTitle == '修改手机' ? '3' : '')">{{ yzmTitle }}</span>
        </div>
        <div class="dataBtnSubmit" @click="editTypeShow1()">确认</div>
      </div>

      <div v-if="editType == 4">
        <div style="font-size: 0.12rem; color: #86909c; margin-bottom: 0.2rem">
          验证成功，绑定邮箱
        </div>
        <div class="yzmInt" style="margin-bottom: 0.2rem">
          <el-input border="none" v-model="newMail" placeholder="输入邮箱" />
        </div>
        <div class="dataBtnSubmit" @click="editTypeShow('5')">确认</div>
      </div>
      <div v-if="editType == 5">
        <div style="
            font-size: 0.14rem;
            color: #86909c;
            margin-bottom: 0.2rem;
            text-align: center;
          ">
          系统已向你的邮箱{{
            newMail
          }}发送了一封验证邮件，请前往邮箱完成验证操作。
        </div>
        <div style="display: flex; justify-content: center">
          <div class="dataBtnSubmit" style="
              color: ;
              border: 1px solid #86909c;
              color: #333333;
              background: #fff;
            " @click="IHaveVerified">
            我已验证
          </div>
          <div class="dataBtnSubmit" @click="GoToVerify()">前往验证</div>
        </div>
      </div>

      <!-- 微信解除绑定 -->
      <div v-if="editType == 6">
        <div style="width: 0.4rem; height: 0.4rem; margin: 0 auto">
          <img style="100%;height: 100%;" src="@/assets/img/tips／exclamation-circle-fill@2x.png" />
        </div>

        <div style="text-align: center; font-size: 0.16rem; margin: 0.16rem 0">
          确认要解除绑定吗
        </div>
        <div style="display: flex; justify-content: center">
          <div class="dataBtnClose" @click="eidtVisible = false">取消</div>
          <div class="dataBtnSubmit" @click="wxjbFun()">确认</div>
        </div>
      </div>
    </el-dialog>
    <!-- 微信绑定 -->

    <div v-if="wxbd" class="wxbd">
      <div>
        <span class="wxbd_span1">使用微信扫码进行绑定</span>
        <span class="wxbd_span2">标识山西</span>
        <div class="wxbd_imgBody">
          <div v-if="codeUrl == ''" class="wxbd_imgBody_bg"></div>
          <img class="wxbd_imgBody_img" v-if="codeUrl != ''" :src="codeUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onUnmounted, watch } from "vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus";
import { checkPasswordRule,level } from './CheckPassword';

let userList = ref({
  openUserid: "",
});
let wxbd = ref(false);
let codeUrl = ref("");
const getInfoAxios = () => {
  return new Promise((resolve, reject) => {
    Axios("GET", "/member/login-info", false, false, function (res) {
      if (res.data.code == 200) {
        resolve(res.data.data);
      } else {
        reject("失败");
      }
    });
  });
};
const getInfo = async () => {
  userList.value = await getInfoAxios();
};
if (localStorage.getItem("userList")) {
  getInfo();
}

// 获取微信二维码
let getwx_rwm = function () {
  Axios("GET", "/auth/member/wx-qrcode", null, false, function (res) {
    codeUrl.value = res.data.data.qrCodeUrl;
    console.log(res);
    getWXopenID(res.data.data.scene);
  });
};
let setTimer = ref();
//获取微信的openID
let getWXopenID = function (id) {
  clearInterval(setTimer.value);
  let timer = 60;
  setTimer.value = setInterval(function () {
    if (timer != 0) {
      timer -= 1;
      Axios("GET", "/member/wx-login/" + id, null, false, function (res) {
        // codeUrl.value = res.data.data.qrCodeUrl
        console.log(res.data);
        console.log(res.data.data);
        if (res.data.data.isScan) {
          clearInterval(setTimer.value);
          wxbdFun(res.data.data.openId);
          //   ElMessage({
          //     showClose: true,
          //     message: "暂未绑定账号,请前往注册绑定",
          //     type: "warning",
          //   });
          //   moduleID.value = 1;
        } else {
        }
      });
    } else {
      clearInterval(setTimer.value);
    }
  }, 1000);
};
// /member/setting-openid   微信绑定
let wxbdFun = function (id) {
  Axios("POST", "/member/setting-openid/" + id, false, false, function (res) {
    if (res.data.code == 200) {
      ElMessage({
        showClose: true,
        message: "绑定成功",
        type: "success",
      });
      getInfo();
      wxbd.value = false;
    }
  });
};
//微信解除绑定
let wxjbFun = function () {
  Axios("POST", "/member/setting-openid-cancel", false, false, function (res) {
    ElMessage({
      showClose: true,
      message: "解绑成功",
      type: "success",
    });
    eidtVisible.value = false;
    getInfo();
  });
};
let eidtVisible = ref(false);
let editType = ref(1);
let newPassword = ref("");
let newMail = ref("");
let newCell = ref("");
let dialogTitle = ref("");

const editShow = (type) => {
  // if (type == 1) {
  //   dialogTitle.value = "密码修改";
  // }
  // if (type == 2) {
  //   dialogTitle.value = "密码修改";
  // }
  // if (type == 3) {
  //   dialogTitle.value = "修改手机";
  // }
  // if (type == 4) {
  //   dialogTitle.value = "修改邮箱";
  //   eidtVisible.value = true;
  // }
  // if (type == 5) {
  //   dialogTitle.value = "绑定邮箱";
  //   eidtVisible.value = true;
  // }
  // // 微信解绑/绑定
  // if (type == 6) {
  //   console.log("1111");
  //   if (userList.value.openUserid) {
  //     console.log("1111-1");
  //     eidtVisible.value = true;
  //     editType.value = type;
  //   } else {
  //     console.log("1111-2");
  //     getwx_rwm();
  //     wxbd.value = true;
  //   }
  // }
  switch (type) {
    case "1":
      dialogTitle.value = "密码修改";
      eidtVisible.value = true;

      break;
    case "2":
      dialogTitle.value = "密码修改";
      eidtVisible.value = true;

      break;
    case "3":
      dialogTitle.value = "修改手机";
      eidtVisible.value = true;

      break;
    case "4":
      dialogTitle.value = "绑定邮箱";
      eidtVisible.value = true;

      break;
    case "5":
      dialogTitle.value = "绑定邮箱";
      eidtVisible.value = true;

      break;
    case "6":
      if (userList.value.openUserid) {
        console.log("1111-1");
        eidtVisible.value = true;
        editType.value = type;
      } else {
        console.log("1111-2");
        getwx_rwm();
        wxbd.value = true;
      }
      break;
    default:
      dialogTitle.value = "";
  }
};
// 关闭弹出框清空输入
const handleClose = () => {
  yzm_code.value = "";
  newPassword.value = "";
  newCell.value = "";
  newMail.value = "";
  eidtVisible.value = false;
  editType.value = 1;
  yzmNumber.value = 60;
  yzmTitle.value = "发送验证码";
  clearInterval(timer.value);
  timer.value = null
};
// 修改邮箱
const editTypeShow = (type) => {
  const pattern =
    /^[a-zA-Z0-9_\u4e00-\u9fa5]+([-_.][a-zA-Z0-9_\u4e00-\u9fa5]+)*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*(\.[a-zA-Z]{2,})$/;
  if (!pattern.test(newMail.value))
    return ElMessage.warning("请输入正确的邮箱格式");
  let validDomains = ["qq.com", "163.com"];
  console.log(newMail.value);
  function checkEmailDomain(email) {
    const domain = email.split("@")[1].toLowerCase();
    for (let i = 0; i < validDomains.length; i++) {
      if (domain === validDomains[i]) {
        return [true, validDomains[i]];
      } else {
        return [false, email.split("@")[1].toLowerCase()];
      }
    }
  }
  if (checkEmailDomain(newMail.value)[0]) {
    Axios(
      "POST",
      `/member/setting-email/${newMail.value}`,
      {},
      false,
      function (res) {
        editType.value = type;
      }
    );
  } else {
    ElMessage.warning(
      `输入邮箱后缀不支持${checkEmailDomain(newMail.value)[1]
      }\n 支持${validDomains.join(", ")}`
    );
  }
};
//我已验证
const IHaveVerified = async () => {
  await getInfo();
  userList.value.emailStatus == 1
    ? ElMessage.warning("邮箱已发送,请前往验证")
    : "";
  userList.value.emailStatus == 3 ? ElMessage.warning("请重新绑定邮箱") : "";
  userList.value.emailStatus == 2
    ? (ElMessage.warning("验证通过"), handleClose())
    : "";
};
const GoToVerify = () => {
  let validDomains = [
    { lable: "qq.com", value: "https://mail.qq.com/" },
    { lable: "163.com", value: "https://mail.163.com/" },
  ];
  function checkEmailDomain(email) {
    const domain = email.split("@")[1].toLowerCase();
    for (let i = 0; i < validDomains.length; i++) {
      if (domain === validDomains[i].lable) {
        return [true, validDomains[i].value];
      } else {
        return [false, email.split("@")[1].toLowerCase()];
      }
    }
  }
  window.open = checkEmailDomain(newMail.value)[1];
};
// 修改手机号提交
const editTypeShow1 = () => {
  Axios(
    "get",
    "/member/setting-phonenumber/",
    { phonenumber: newCell.value, smsCode: yzm_code1.value },
    false,
    function (res) {
      console.log(res);
      if (res.data.code === 200) {
        ElMessage.success("修改手机号成功");
        handleClose();
      }
    }
  );
};
let yzm_code = ref();
let yzm_code1 = ref();

const yzmTitle = ref("发送验证码");
const yzmNumber = ref(60);
let timer = ref();
/* 发送验证码 */
// 短信类型(MOBILE_LOGIN 登录,RESET_PASSWORD 修改密码,MOBILE_REGISTER 注册,MOBILE_EMAIL 修改邮件,MOBILE_NOTICE 系统通知)

let fs_yzm = function (type) {
  if (yzmNumber.value == 60) {
    console.info(type)
    let phonenumber = JSON.parse(localStorage.getItem("userList"));
    let params = {
      mobile: newCell.value ? newCell.value : phonenumber.phonenumber,
      // code: yzm_code.value,
      smsEvent:
        type == "2"
          ? "RESET_PASSWORD"
          : type == "3"
            ? "MOBILE_LOGIN"
            : type == "4"
              ? "MOBILE_EMAIL"
              : "",
    };

    Axios("POST", "/system/sms/sendSms", params, false, function (res) {
      console.log(res);
      if (res.data.code == 200) {
        ElMessage.success("发送成功");
      }
      timer.value = setInterval(function () {
        if (yzmNumber.value != 0) {
          yzmNumber.value = yzmNumber.value - 1;
          yzmTitle.value = yzmNumber.value + 's';
        } else {
          yzmNumber.value = 60;
          yzmTitle.value = "发送验证码";
          clearInterval(timer.value);
        }
      }, 1000);
    });
  }
};

/* 验证短信 */
let qr_yzm = function (type) {
  if (!yzm_code.value) return ElMessage.warning("请输入验证码");
  let phonenumber = JSON.parse(localStorage.getItem("userList"));
  let params = {
    mobile: phonenumber.phonenumber,
    event:
      dialogTitle.value == "绑定邮箱"
        ? "MOBILE_EMAIL"
        : "" || dialogTitle.value == "密码修改"
          ? "RESET_PASSWORD"
          : "" || dialogTitle.value == "修改手机"
            ? "MOBILE_LOGIN"
            : "",
    code: yzm_code.value,
  };
  Axios("get", "/system/sms/validate-code", params, false, function (res) {
    yzmNumber.value = 0;
    yzmTitle.value = "发送验证码";
    editType.value = type;
  });
};
/* 提交修改密码 */
let tg_xgmm = function () {
  let phonenumber = JSON.parse(localStorage.getItem("userList"));
  const result: string = checkPasswordRule(newPassword.value)
  if (result != '校验通过') {
    ElMessage.error(result);
  }

  let params = {
    mobile: phonenumber.phonenumber,
    smsCode: yzm_code.value,
    password: newPassword.value,
  };
  Axios("post", `/member/update-pwd`, params, false, function (res) {
    ElMessage.success("修改成功");
    editType.value = 0;
    eidtVisible.value = false;
  });
};


// 强度条颜色
const barColor = ref('');
// 强度条长度
const width = ref('');
// 强度条说明
const strength = ref('');

watch(() => newPassword.value, (newVal, oldVal) => {
  console.log(`Message changed from "${oldVal}" to "${newVal}"`)
  console.log(1111)
  console.log(newPassword.value)
  if (newPassword.value != '') {
    const res: string = level(newPassword.value);
    if (res == '非常弱') {
      barColor.value = 'red';
      width.value = '20';
      strength.value = '非常弱';
    } else if (res == '弱') {
      barColor.value = '#ee795c';
      width.value = '40';
      strength.value = '弱';
    } else if (res == '一般') {
      barColor.value = 'orange';
      width.value = '60';
      strength.value = '一般';
    } else if (res == '强') {
      barColor.value = 'green';
      width.value = '80';
      strength.value = '强';
    } else if (res == '非常强') {
      barColor.value = '#1B8EF8';
      width.value = '100';
      strength.value = '非常强';
    }
    console.log(strength.value)
  }
})

/* 修改密码 */
// let xgmm = function () {
// 	// Axios('POST', '/member/update-pwd', {},)
// }
onUnmounted(() => {
  clearInterval(timer.value);
  clearInterval(setTimer.value);
});


</script>

<style scoped>
.strength {
  font-size: 13px;
  color: #271E25;
  position: relative;
  top: 5px;
  left: 0;
  transition: 0.5s all ease;
}

.bar {
  width: 100%;
  height: 5px;
  background: red;
  transition: 0.5s all ease;
  max-width: 100%;
  margin: 2px 0 5px 5px;
  /* position: absolute; */
}


.item_box {
  display: flex;
  justify-content: space-between;
  padding: 0.44rem 0.02rem;
  box-sizing: border-box;
}

.item_box span:first-child {
  width: 0.66rem;
}

.item_box span:nth-child(2) {
  width: calc(100% - 0.66rem - 0.28rem);
}

.item_box span:nth-child(3) {
  width: 0.28rem;
  color: #165dff;
}

.item_line {
  border-bottom: 1px solid #e5e6eb;
  width: calc(100% - 0.66rem);
  margin-left: 0.66rem;
}

.dataBtnSubmit {
  color: #fff;
  background: #C01A26;
  margin: 0.2rem 0.1rem;
}

.yzmInt {
  display: flex;
  justify-content: space-between;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  opacity: 1;
  border: 0.01rem solid #e5e6eb;
  padding: 0.12rem;
  box-sizing: border-box;
  align-items: center;
}

.yzmInt>input {}

/deep/.el-dialog.is-align-center {
  border-radius: 20px !important;
}

/deep/.el-input__wrapper {
  border: none !important;
}

.wxbd {
  position: fixed;
  width: 100%;
  height: calc(100vh);
  background: #fff;
  z-index: 999;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.wxbd>div {
  width: 3rem;
}

.wxbd>div>span {
  display: block;
  text-align: center;
}

.wxbd_span1 {
  font-size: 0.14rem;
}

.wxbd_span2 {
  font-size: 0.2rem;
  margin: 0.15rem 0;
}

.wxbd_imgBody {
  width: 3rm;
  height: 3rem;
}

.wxbd_imgBody_bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.wxbd_imgBody_img {
  width: 100%;
  height: 100%;
}
</style>
